import React, { useState } from "react";
import {
  Box, Typography, TextField, Button, Grid,
  FormControl, InputLabel, Select, MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";

import { createDataType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import { COMPANY_ID } from "../../config/appConfig";

const DATA_CLASS_OPTIONS = [
  "MasterData", "TransactionData", "AccountData", "ReferenceData",
  "ManagementData", "Document", "Image", "Video", "Audio", "None",
];

export default function DataTypeCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({
    dataTypeName: "",
    dataTypeDescription: "",
    dataClass: "TransactionData",
    dataOwner: "",
    address: "",
    dataSensitivityLevel: "",
    dataRestrictedCategory: "",
    url: "",
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createDataType({ ...form, companyId: COMPANY_ID, businessDomainId });
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/data-types`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("dataType.create.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required multiline label={t("dataType.name")}
              name="dataTypeName" value={form.dataTypeName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("dataType.description")}
              name="dataTypeDescription" value={form.dataTypeDescription} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("dataType.dataClass")}</InputLabel>
              <Select name="dataClass" value={form.dataClass} label={t("dataType.dataClass")} onChange={handleChange}>
                {DATA_CLASS_OPTIONS.map((opt) => (
                  <MenuItem key={opt} value={opt}>{t(`dataType.class.${opt}`)}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField fullWidth label={t("dataType.dataOwner")}
              name="dataOwner" value={form.dataOwner} onChange={handleChange} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField fullWidth type="email" label={t("dataType.dataOwnerMailAddress")}
              name="address" value={form.address} onChange={handleChange} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField fullWidth label={t("dataType.dataSensitivityLevel")}
              name="dataSensitivityLevel" value={form.dataSensitivityLevel} onChange={handleChange} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField fullWidth label={t("dataType.dataRestrictedCategory")}
              name="dataRestrictedCategory" value={form.dataRestrictedCategory} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth type="url" label={t("common.url")}
              name="url" value={form.url} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/data-types`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
